import React from "react";
import { Alert, Box, Button, Link, Typography } from "@mui/material";
import BaseModal from "./BaseModal";
import FormField from "../forms/FormField";
import ShopifyCreateCustomerAccessToken from "../../utils/ShopifyCreateCustomerAccessToken";
import BaseDrawer from "./mobile/BaseDrawer";

const SignInModal = ({ onClose, setModal, modal, isMobile = false, data }) => {
  const { initCheckout, prevType } = modal;
  const Modal = isMobile ? BaseDrawer : BaseModal;

  const [form, setForm] = React.useState({
    values: {
      email: "",
      password: "",
    },
    valid: false,
    loading: false,
  });
  const [error, setError] = React.useState("");

  React.useEffect(() => {
    if (form.values.email && form.values.password) {
      setForm((state) => ({
        ...state,
        valid: true,
      }));
    } else {
      setForm((state) => ({
        ...state,
        valid: false,
      }));
    }
  }, [form.values]);

  const handleChange = (event) => {
    const { name, value } = event.target;
    setForm((state) => ({
      ...state,
      values: {
        ...state.values,
        [name]: value,
      },
    }));
  };

  const handleForgotPassword = () => {
    setModal({ type: "RESET_PASSWORD" });
  };

  const handleSignIn = () => {
    setError(null);
    setForm((state) => ({
      ...state,
      loading: true,
    }));
    ShopifyCreateCustomerAccessToken(form.values.email, form.values.password).then(
      ({ customerUserErrors, customerAccessToken }) => {
        setForm((state) => ({
          ...state,
          loading: false,
        }));
        if (customerUserErrors.length) {
          switch (customerUserErrors[0].code) {
            case "UNIDENTIFIED_CUSTOMER":
              setError("Sorry, your email or password isn't valid.");
              break;
            default:
              setError("Sorry, something went wrong. Please try again.");
          }
        } else {
          sessionStorage.setItem("sup_token", customerAccessToken.accessToken);
          data.setToken(customerAccessToken.accessToken);

          const type = prevType === "SAVE_DESIGN";

          if (initCheckout && !type) {
            setModal({ type: "ATB_DISCLAIMER" });
          } else if (type) {
            setModal({ type: "SAVE_DESIGN" });
          } else {
            onClose();
          }
        }
      }
    );
  };

  return (
    <Modal headline={isMobile ? "Please sign in" : "Sign In"} onClose={onClose}>
      {error && (
        <Alert severity="error" sx={{ marginBottom: "20px" }}>
          {error}
        </Alert>
      )}
      <FormField
        isKiosk={data.isKiosk}
        label="Email Address"
        name="email"
        handleChange={handleChange}
      />
      <FormField
        isKiosk={data.isKiosk}
        label="Password"
        type="password"
        name="password"
        handleChange={handleChange}
      />
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          gap: "15px",
        }}
      >
        <Button
          variant="contained"
          sx={{
            width: "100%",
            maxWidth: "280px",
          }}
          disabled={form.loading || !form.valid}
          onClick={handleSignIn}
        >
          {form.loading ? "Signing in..." : "Sign In"}
        </Button>
        <Typography>OR</Typography>
        <Typography>
          {"Don't have an account yet? "}
          <Link
            onClick={() =>
              setModal({
                prevType,
                type: "SIGN_UP",
                initCheckout,
              })
            }
          >
            Sign up here
          </Link>
        </Typography>
        {error && <Link onClick={handleForgotPassword}>Forgot your password?</Link>}
      </Box>
    </Modal>
  );
};

export default SignInModal;
